import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import PasskeyHelpModal from 'src/components/ui/PasskeyHelpModal';
import useUser from 'src/hooks/useUser';
import { isAppleDevice, isWebAuthnSupported } from 'src/utils';
import useSentryUserEffect from 'src/hooks/useSentryUserEffect';
import useSkeletonCleanup from 'src/init/useSkeletonCleanup';

const AuthenticatedPage = () => {
  const { user, loading, error } = useUser();
  useSentryUserEffect(user);
  useSkeletonCleanup(loading);

  if (loading) return null;
  if (!user?.clientId || error) return <Navigate to="/login" />;

  return (
    <>
      <Outlet />
      {isAppleDevice && isWebAuthnSupported && (
        <PasskeyHelpModal clientId={String(user.clientId)} />
      )}
    </>
  );
};

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedPage,
});
